import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { bgcolor, useTheme } from "@mui/system";
import { COLOR_MAIN } from "../utils/Colors";
import { useTranslation } from "react-i18next";

const logos = [
  require("../assets/images/sponsors/gswf_sponsor_image.png"),
  require("../assets/images/sponsors/platina_logo_sponsor.png"),
  require("../assets/images/sponsors/q_wave_image.png"),
  require("../assets/images/sponsors/rodeo_sponsor_image.png"),
];

const logoStyle = {
  width: "180px",
  height: "140px",
  margin: "0 22px",
};

export default function LogoCollection() {
  const { t } = useTranslation();
  return (
    <Box id="logoCollection" sx={{ py: 4 }}>
      <Typography
        component="p"
        variant="subtitle2"
        align="center"
        sx={{ color: "text.secondary" }}
      >
        {t("sponsored_by_these_companies")}
      </Typography>
      <Grid container sx={{ justifyContent: "center", mt: 2 }}>
        {logos.map((logo, index) => (
          <Grid key={index}>
            <Box
              component={"img"}
              src={logo}
              alt={`Fake company number ${index + 1}`}
              sx={[
                logoStyle,
                { objectFit: index == 2 || index == 1 ? "contain" : "cover" },
              ]}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
